@if (state(); as s) {
  <app-anchored-popup
    [anchorEl]="s.anchorEl"
    [placement]="s.data.placement"
    [width]="300"
    [owner]="popupService"
    (dismiss)="popupService.close()">
    <app-kpi-detail-card
      [title]="s.data.labelKey | translate"
      [rows]="s.data.rows"
      (dismiss)="popupService.close()" />
  </app-anchored-popup>
}
